import { useEffect, useState } from "react";

function EditCompanyModal({ company, isOpen, onClose, onSave, industries }) {
  const [formData, setFormData] = useState({
    name: "",
    registeredName: "",
    industryId: "",
    contactNumber: "",
    emailAddress: "",
    websiteUrl: "",
  });

  useEffect(() => {
    if (company) {
      setFormData({
        name: company.name || "",
        registeredName: company.registeredName || "",
        industryId: company.industries?.[0]?.id?.toString() || "",
        contactNumber:
          company.contacts.find((x) => x.contactType === 1).value || "",
        emailAddress:
          company.contacts.find((x) => x.contactType === 5).value || "",
        websiteUrl: company.websiteUrl || "",
      });
    }
  }, [company]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const updatedPayload = {
      ...company,
      name: formData.name,
      registeredName: formData.registeredName,
      industryIds: [parseInt(formData.industryId)],
      contactNumber: formData.contactNumber,
      emailAddress: formData.emailAddress,
      websiteUrl: formData.websiteUrl,
    };
    onSave(updatedPayload);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 w-[600px] relative border-2 border-[#6f81f5]">
        <button onClick={onClose} className="absolute top-3 right-4 text-xl">
          ×
        </button>
        <h2 className="text-xl font-semibold mb-6">Edit Company Profile</h2>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block mb-1 font-medium">Company Name:</label>
            <input
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium">Registered Name:</label>
            <input
              name="registeredName"
              value={formData.registeredName}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium">Industry:</label>
            <select
              name="industryId"
              value={formData.industryId}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded"
            >
              <option value="">Select Industry</option>
              {(industries || []).map((industry) => (
                <option key={industry.id} value={industry.id}>
                  {industry.value}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block mb-1 font-medium">Contact Number:</label>
            <input
              name="contactNumber"
              value={formData.contactNumber}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium">Email Address:</label>
            <input
              name="emailAddress"
              value={formData.emailAddress}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded"
              type="email"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium">Website:</label>
            <input
              name="websiteUrl"
              value={formData.websiteUrl}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded"
            />
          </div>
        </div>

        <div className="text-right mt-6">
          <button
            onClick={handleSubmit}
            className="bg-green-700 text-white px-6 py-2 rounded hover:opacity-90"
          >
            Save Changes →
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditCompanyModal;
